import { render } from "./pointListU.vue?vue&type=template&id=7484ab8b&scoped=true"
import script from "./pointListU.vue?vue&type=script&lang=js"
export * from "./pointListU.vue?vue&type=script&lang=js"

import "./pointListU.vue?vue&type=style&index=0&id=7484ab8b&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./pointListU.vue?vue&type=style&index=2&id=7484ab8b&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7484ab8b"]])

export default __exports__